import React from 'react';
import clsx from 'clsx';
import {
  clientErrors, firstErrorMessage, firstResponseError, translatedError,
} from '@/utils/errors';
import DialogWrapper from '@/components/dialogs/DialogWrapper';
import { states } from '@/constants/lifecycle';
import { validateFormObjects } from '../../helper';
import { transformFormObjects } from '../../state/state';
import FormObjectInformationHeader from './FormObjectInformationHeader';
import FormObjectActions from './FormObjectActions';
import formFieldTypes from '../../constants';
import FormObjectModalContent from './FormObjectModalContent';

const buildClasses = (fields) => {
  const types = fields.map(({ type }) => type);
  const isSmallWizard = fields.length > 6
    || types.includes(formFieldTypes.MD.type)
    || types.includes(formFieldTypes.TEXT.type);

  return clsx('aridhia-form-object-dialog', isSmallWizard && 'smallwizard');
};

const FormObjectDialog = ({
  activeIndex,
  allowAdd,
  allowRemove,
  canEdit,
  category,
  changeItem,
  code,
  component,
  deleteItem,
  entity,
  field,
  fields,
  hide,
  insertItem,
  isDirty,
  isEditing,
  item,
  items,
  onSave,
  saveErrors,
  saveStatus,
  showEdit,
  textField,
  theme,
  updateObjectsProperties,
  updateProperties,
}) => {
  const setErrors = (newErrors) => updateObjectsProperties({ properties: { saveErrors: newErrors } });

  const setStatus = (status) => updateObjectsProperties({ properties: { saveStatus: status } });

  const validateForm = () => {
    const errors = validateFormObjects(field, transformFormObjects(items));
    if (errors.length > 0 && !firstResponseError(errors)) {
      const message = firstErrorMessage(errors);
      errors.unshift(translatedError(
        'server',
        'validation.general.invalid.title',
        message === 'validation.general.duplicates' ? message : 'validation.general.invalid',
      ));
    }
    return errors;
  };

  const submitForm = () => {
    setStatus(states.PENDING);
    const errors = validateForm();
    setErrors(errors);

    if (errors.length > 0) {
      setStatus(states.NONE);
    } else {
      onSave();
    }
  };

  return (
    <DialogWrapper
      className={buildClasses(field?.fields || [])}
      error={firstResponseError(saveErrors)}
      onClose={hide}
      onDismiss={() => setErrors(clientErrors(saveErrors))}
      size="small"
      theme={theme}
      title={field?.label}
    >
      {(item) && (
        <FormObjectInformationHeader
          activeIndex={activeIndex}
          allowAdd={allowAdd}
          allowRemove={allowRemove}
          canEdit={canEdit}
          changeItem={changeItem}
          deleteItem={deleteItem}
          entity={entity}
          errors={saveErrors}
          field={field}
          insertItem={insertItem}
          items={items}
          textField={textField}
        />
      )}
      <FormObjectModalContent
        activeIndex={activeIndex}
        canEdit={canEdit}
        category={category}
        code={code}
        component={component}
        entity={entity}
        errors={saveErrors}
        field={field}
        fields={fields}
        insertItem={insertItem}
        isEditing={isEditing}
        item={item}
        showEdit={showEdit}
        updateProperties={updateProperties}
      />
      <FormObjectActions
        activeIndex={activeIndex}
        canEdit={canEdit}
        changeItem={changeItem}
        isDirty={isDirty}
        items={items}
        onClose={hide}
        onSave={submitForm}
        saveStatus={saveStatus}
      />
    </DialogWrapper>
  );
};

export default FormObjectDialog;
